import { IElement, ITextAttributes } from '@routes/private/Editor/types';
import { IBrandDefinition, IBrandConfigFont } from '@state/dsconfig/types';
import { IDSConfig } from '@state/dsconfig/types';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import _ from 'lodash';

export type itemKey = "id" | "name";

export enum IFontStatusEnum {
  UNLOADED = "unloaded",
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error"
}

export const findFontsDefinition = (oemDefinitions: IBrandDefinition[], oem?: string, otherbrands?: boolean) => {
    if (otherbrands) {
      return oemDefinitions.filter((oemDefinition) => (!oemDefinition.oem && !oemDefinition.useAsCommon && !oemDefinition.genericOrOther));
    }
    if(!oem || oem === "common") {
        return oemDefinitions.filter(oemDefinition => {
          var isEqual = oemDefinition.useAsCommon === true;
          var isNotEqual = oemDefinition.useAsCommon !== true;
          return oem === "common" ? isEqual : isNotEqual;
        }).sort((a, b) => {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        }).map(oemDefinition => { return {
          ...oemDefinition,
          fonts: oemDefinition.fonts?.sort((a, b) => {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          }) ?? []
        }});
    } else {
        return oemDefinitions.filter((oemDefinition) => (oemDefinition.id === oem));
    }
}

export const getFonts = (dsConfig: IDSConfig, oem?: string, otherbrands?: boolean) => {
  if (dsConfig) {
    let oemFontsDefinitions = findFontsDefinition(dsConfig.brands, oem);
    let oemFontsList = _.flatten(oemFontsDefinitions.map(oemFontsDefinition => {return oemFontsDefinition.fonts?oemFontsDefinition.fonts:[]}));
    let notOEMFontsList: IBrandConfigFont[] = [];
    if (otherbrands) {
      let notoemFontsDefinitions = findFontsDefinition(dsConfig.brands, undefined, true);
      notOEMFontsList = _.flatten(notoemFontsDefinitions.map(notoemFontsDefinition => {return notoemFontsDefinition.fonts?notoemFontsDefinition.fonts:[]}));
    }
    let newFontsList: IBrandConfigFont[] = [...oemFontsList, ...notOEMFontsList];
    newFontsList.sort((a, b) => {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    return newFontsList;
  }
  return [];
}

export const findOEMByNameOrId = (dsConfig: IDSConfig, key: itemKey, value: string): IBrandDefinition | undefined => {
    return dsConfig?.brands.find(oem => oem[key] === value);
}

export const findFontByNameOrId = (oemDefinitions: IBrandDefinition[], key: itemKey, value: string): IBrandConfigFont | undefined => {
  let result: IBrandConfigFont | undefined = undefined;
  oemDefinitions.map((oemDefinition, oemIndex: number) => {
    const fontIndex = oemDefinition.fonts?.findIndex(font => font[key] === value || font.aliases?.includes(value));
    if (fontIndex >= 0) result = {...oemDefinitions[oemIndex].fonts[fontIndex], oemId: oemDefinition.id};
  })
  return result;
}

const getFontsFromParsedTree = (element: any,fontsFound?: string[]): string[] => {
  let fonts: string[] = fontsFound??[];
  if (element.type === "Text") {
    if (element && element.attributes && (element.attributes as ITextAttributes).style && (element.attributes as ITextAttributes).style.fontFamily && (element.attributes as ITextAttributes).style.fontFamily!=="" && !fonts.includes((element.attributes as ITextAttributes).style.fontFamily!)) {
        fonts.push((element.attributes as ITextAttributes).style.fontFamily!);
    }
    if (element && element.attributes && (element.attributes as ITextAttributes).parts && (element.attributes as ITextAttributes).parts.length>0) {
      for (let i=0;i<(element.attributes as ITextAttributes).parts.length;i++) {
        if ((element.attributes as ITextAttributes).parts[i].style && (element.attributes as ITextAttributes).parts[i].style.fontFamily && (element.attributes as ITextAttributes).parts[i].style.fontFamily!=="" && !fonts.includes((element.attributes as ITextAttributes).parts[i].style.fontFamily!)) {
          fonts.push((element.attributes as ITextAttributes).parts[i].style.fontFamily!);
        }
      }
    }
  }
  if (element && element.children && element.children.length>0) {
    for (let i=0;i<element.children.length;i++) {
      fonts = getFontsFromParsedTree(element.children[i], fonts);
    }
  }
  return fonts;
}

export const getFontsToLoad = (dsConfig: IDSConfig, data: IElement): IBrandConfigFont[] => {
  let oemFontsToLoad: IBrandConfigFont[] = [];
  const fontsToLoad = getFontsFromParsedTree(data);
  fontsToLoad.map(fontToLoad => {
    const font = findFontByNameOrId(dsConfig.brands, "id", fontToLoad);
    if (font) oemFontsToLoad = [...oemFontsToLoad, font];
  });
  return oemFontsToLoad;
}

export const checkLoadedFont = (font: IBrandConfigFont) => {
  let isLoaded = false;
  document.fonts.forEach((value: FontFace) => {
    if (`font-${font.id}` === value.family && value.status === IFontStatusEnum.LOADED) {
      isLoaded = true;
      return;
    }
  });
  return isLoaded;
}

export const loadFont = (fontName: string, url: string | ArrayBuffer) => {
  return new Promise<boolean>((resolve, reject) => {
    var junction_font = new FontFace(`${fontName}`, url);
    junction_font.load().then(function(loaded_face) {
      document.fonts.add(loaded_face);
      resolve(true);
    }).catch(function(error) {
      console.error(error);
      reject(false);
    });  
  })
}

export const loadOEMFont = async (brandId: string | undefined, font: IBrandConfigFont) => {
  if (!brandId) return false;
  else return await loadFont(`font-${font.id}`, `url(https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}/${brandId}/fonts/${font.id}.${font.ext})`);
}

export const addFontsFromDSConfig = (dsConfig: IDSConfig) => {
  return new Promise(() => {
    dsConfig.brands.map(oem => {
      oem.fonts?.map(font => {
        if (!checkLoadedFont(font)) loadOEMFont(oem.id, font);
      })
    })
  })
}